// extracted by mini-css-extract-plugin
export default {"group":"index-module__group___m8_pn"};